// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","351":"commons"}[chunkId] || chunkId) + "-" + {"223":"4202650e7716e0e35f55","230":"559248ac700683b1e2b9","256":"8c4dc856499427d83ad3","351":"f5227e2edccad11d7109","843":"74611e7bfaf5d8ed8988"}[chunkId] + ".js";
};